export default __webpack_public_path__ + "static/metal-style-1-acc9a88b9257dc3ce2dac8bc1f7b9893.png";